<template>
  <el-dialog :title="$t('paymentAdapt.keyTitle', { name: vendorName })" :visible.sync="visible" width="700px">
    <div class="param-danger" style="background:#fff1f0;border:1px solid #ffa39e;color:#cf1322;border-radius:6px;padding:8px 12px;margin-bottom:12px;font-size:13px;line-height:1.6;">
      <b>⚠ 危险参数，请勿随意修改！</b><br>
      参数项模板定义"该厂家需要填哪些参数"（下拉时动态渲染输入框）。
      <u>columnKey 是后端代码硬编码读取的参数名</u>（如 WECHAT_MCHID 商户号、WECHAT_KEY API密钥），
      改错会导致参数读取不到、支付失败。新增 / 改名参数项前请先与开发确认 Key 名称。
    </div>
    <el-table v-loading="loading" :data="keyList" border style="width:100%">
      <el-table-column prop="name" :label="$t('paymentAdapt.keyName')" align="center" />
      <el-table-column prop="columnKey" :label="$t('paymentAdapt.columnKey')" align="center" />
      <el-table-column prop="remark" :label="$t('paymentAdapt.remark')" align="center" show-overflow-tooltip />
      <el-table-column :label="$t('paymentAdapt.operation')" align="center" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="openEdit(scope.row)">{{ $t('paymentAdapt.edit') }}</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{ $t('paymentAdapt.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-form ref="keyForm" :model="keyForm" :rules="keyRules" label-width="110px" style="margin-top:16px">
      <el-form-item :label="$t('paymentAdapt.keyName')" prop="name">
        <el-input v-model="keyForm.name" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.columnKey')" prop="columnKey">
        <el-input v-model="keyForm.columnKey" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('paymentAdapt.remark')">
        <el-input v-model="keyForm.remark" :placeholder="$t('paymentAdapt.remarkPlaceholder')" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" :loading="submitting" @click="submitKey">
        {{ keyForm.keyId ? $t('paymentAdapt.editKey') : $t('paymentAdapt.addKey') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listPaymentKey, savePaymentKey, updatePaymentKey, deletePaymentKey } from '@/api/system/paymentAdaptApi'

export default {
  name: 'PaymentKeyManage',
  data() {
    return {
      visible: false,
      loading: false,
      submitting: false,
      vendorName: '',
      paymentType: '',
      keyList: [],
      keyForm: {
        keyId: '',
        name: '',
        columnKey: '',
        remark: ''
      },
      keyRules: {
        name: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'blur' },
          { max: 64, message: this.$t('paymentAdapt.maxLength64'), trigger: 'blur' }
        ],
        columnKey: [
          { required: true, message: this.$t('paymentAdapt.requiredField'), trigger: 'blur' },
          { max: 64, message: this.$t('paymentAdapt.maxLength64'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.paymentType = row.paymentType
      this.vendorName = row.name
      this.keyForm = { keyId: '', name: '', columnKey: '', remark: '' }
      this.visible = true
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listPaymentKey({
          paymentType: this.paymentType,
          page: 1,
          row: 100
        })
        this.keyList = res.data || []
      } catch (error) {
        this.$message.error(error.message || '加载参数项失败')
      } finally {
        this.loading = false
      }
    },
    openEdit(row) {
      this.keyForm = {
        keyId: row.keyId,
        name: row.name,
        columnKey: row.columnKey,
        remark: row.remark || ''
      }
    },
    async submitKey() {
      this.$refs.keyForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = {
            ...this.keyForm,
            paymentType: this.paymentType
          }
          if (this.keyForm.keyId) {
            await updatePaymentKey(payload)
          } else {
            await savePaymentKey(payload)
          }
          this.$message.success(this.$t('common.saveSuccess'))
          this.keyForm = { keyId: '', name: '', columnKey: '', remark: '' }
          this.getList()
        } catch (error) {
          this.$message.error(error.message || this.$t('common.saveFail'))
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(this.$t('paymentAdapt.deleteKey'), this.$t('common.confirm'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          await deletePaymentKey({ keyId: row.keyId })
          this.$message.success(this.$t('common.deleteSuccess'))
          this.getList()
        } catch (error) {
          this.$message.error(error.message || this.$t('common.deleteFail'))
        }
      }).catch(() => {})
    }
  }
}
</script>
